import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'

import { DEFAULT_PANEL_WIDTH, PANEL_TRANSITION_DURATION } from './const'

export interface PanelProps {
  content: React.ReactNode
  title: string
  width?: number
  setOpen: (open: boolean) => void
}

export const Panel = ({ content, title, width, setOpen }: PanelProps) => {
  const [panelWidth, setPanelWidth] = useState(0)

  // managing transition on open
  useEffect(() => {
    setTimeout(() => {
      setPanelWidth(width ?? DEFAULT_PANEL_WIDTH)
    }, PANEL_TRANSITION_DURATION)
  }, [width])

  return (
    <Box
      border={{ left: { style: 'solid', width: 's1', color: 'grey400' } }}
      padding="s24"
      height="full"
      overflowY="auto"
      style={{
        opacity: panelWidth > 0 ? '1' : '0', // managing transition with opacity
        width: `${panelWidth}px`,
      }}
    >
      <Box width="full" height="full">
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {title}
          </Text.Normal>
          <Box onClick={() => setOpen(false)}>
            <Icon.Medium icon="cross" />
          </Box>
        </Box>

        {content}
      </Box>
    </Box>
  )
}
